import React from "react"
import { Link } from 'react-router-dom'
import CurrentLink from 'app/dodones/shared/CurrentLink'
import HeaderContext from 'app/HeaderContext'
import { useContext } from 'react'

export default ({ onNav }) => {
  const { MenuContent } = useContext(HeaderContext);

  return <>
           <Link to={ "/dodones/today" } onClick={ onNav }> Today </Link>
           <CurrentLink onNav={ onNav } />
           { MenuContent ? <MenuContent onNav={onNav} /> : null }
         </>
};
